module.exports = __webpack_public_path__ + "img/forms.f2a66a96.svg";